import reducer from './reducer'

import * as portfoliosOperations from './operations'
import * as portfoliosSelectors from './selectors'

export { portfoliosOperations, portfoliosSelectors }

export default reducer